import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import Environment from '../helpers/environment';

// Use this to compute default flags if the API is down
// The return object should be updated once a feature flag is "LOCKED" in the UI
const computeDefaultFlags = () => ({
  wholeMe: true,
  isSaveAndContinueAlwaysEnabled: Environment.isDevMode,
});

const mapFeatureFlags = (flags) => {
  const {
    wholeMe,
    ...rest
  } = flags;
  return {
    isWholeMeEnabled: wholeMe,
    ...rest,
  };
};

const useFeatureFlags = (authorized = false) => {
  const { get, response } = useFetch();
  const [state, setState] = useState({});

  useEffect(() => {
    if (!authorized) {
      if (Object.keys(state).length) setState({});
      return undefined;
    }

    let cancelled = false;
    (async () => {
      let flags = {};
      try {
        const result = await get('/feature-flags/flags');
        if (cancelled) return;
        if (response.ok) {
          flags = result;
        } else {
          throw new Error('Error fetching feature flags');
        }
      } catch (e) {
        if (cancelled) return;
        console.error(e);
        flags = computeDefaultFlags();
      }
      if (cancelled) return;
      setState(mapFeatureFlags(flags));
    })();
    return () => { cancelled = true; };
  }, [authorized]);

  return state;
};

export default useFeatureFlags;
